<template>
  <div>
    <PageLayout>
      <template #pageHeader>
        <router-link
          :to="{
            name: 'applications/landing',
            params: { applicationId: $route.params.applicationId },
          }"
          class="inline-flex items-center text-sm text-gray-700 hover:text-gray-700 hover:underline"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="feather feather-chevron-left w-4 h-4"
          >
            <polyline points="15 18 9 12 15 6" />
          </svg>
          Back
        </router-link>
      </template>
      <template #pageContent>
        <PageSection :id="'form'" :title="'Internship Interests'">
          <template #content>
            <Form />
          </template>
        </PageSection>
      </template>
    </PageLayout>
  </div>
</template>

<script>
import PageSection from "../SharedComponents/Layout/PageSection.vue";
import Form from "./InternshipInterestsForm.vue";
import PageLayout from "../SharedComponents/Layout/PageDefault.vue"
export default {
  name: "InternshipInterestsPage",
  components: {
    PageSection,
    PageLayout,
    Form,
  },
};
</script>
